import Modal from '../Modal';
import { useEffect, useState } from 'react';
import { truncate } from '../../lib/Utils.js';
import { calendarToAccount, TypeToIcon } from '../../lib/CalendarSyncing.jsx';
import SectionHeading from '../SectionHeading.jsx';

const CalendarCheckboxes = ({ accountOptions, value, setValue }) => {
    const [selectedAccounts, setSelectedAccounts] = useState([]);

    function onChange(id, isChecked) {
        if (isChecked) {
            setValue([...value, id]);
        } else {
            const newValue = [...value];
            newValue.splice(value.indexOf(id), 1);
            setValue(newValue);
        }
    }

    // useEffect(() => {
    //     // Make sure accounts selected for everything
    //     let newSelectedAccounts = [...selectedAccounts];
    //     for (let calendarId of value) {
    //         const accountId = calendarToAccount(calendarId, accountOptions);
    //         if (accountId && newSelectedAccounts.indexOf(accountId) < 0) {
    //             newSelectedAccounts.push(accountId)
    //         }
    //     }
    //
    //     setSelectedAccounts(newSelectedAccounts);
    // }, [JSON.stringify(value)]);

    return (
        <div className="">
            {accountOptions.map(account => (
                <div key={account.id} className="mb-6">
                    <SectionHeading>
                        <div className="flex justify-between">
                            <div className="flex items-center">
                                {/*<input*/}
                                {/*    type="checkbox"*/}
                                {/*    className="mr-3"*/}
                                {/*    checked={selectedAccounts.indexOf(account.id) > -1}*/}
                                {/*    onChange={(ev) => ev.target.checked}*/}
                                {/*/>*/}
                                {account.name}
                            </div>
                            {TypeToIcon[account.type]}
                        </div>
                    </SectionHeading>

                    {Object.keys(account.options).map(id => (
                        <label className="my-2 ml-4 block" key={id}>
                            <input
                                type="checkbox"
                                className="mr-3"
                                checked={value.indexOf(parseInt(id)) > -1}
                                onChange={e =>
                                    onChange(parseInt(id), e.target.checked)
                                }
                            />
                            {truncate(account.options[id].name, 40)}
                        </label>
                    ))}
                </div>
            ))}
        </div>
    );
};

const CheckConflictsModal = ({
    isOpen,
    onClose,
    accountOptions,
    value,
    setValue,
    onSave,
}) => {
    const [originalValue, setOriginalValue] = useState(value);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setOriginalValue(value);
            setIsSaving(false);
        }
    }, [isOpen]);

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => {
                if (JSON.stringify(originalValue) !== JSON.stringify(value)) {
                    if (
                        !confirm(
                            'You have unsaved changes, do you want to discard them?',
                        )
                    ) {
                        return;
                    }

                    setValue(originalValue);
                }
                onClose();
            }}
        >
            <h2 className="mb-6">Check for Conflicts</h2>
            <CalendarCheckboxes
                accountOptions={accountOptions}
                value={value}
                setValue={setValue}
            />

            <div className="mt-4 pt-4 border-t -mx-4 px-4">
                <button
                    className="btn-save"
                    type="button"
                    onClick={async () => {
                        setIsSaving(true);
                        await onSave();
                        onClose();
                    }}
                >
                    {isSaving ? 'Saving...' : 'Save'}
                </button>
            </div>
        </Modal>
    );
};

export default CheckConflictsModal;
